// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"4aef32f2347ecb2b79bc","293":"f14cb6226ef1f8dda1f9","518":"5bf8fef6255e34dbee12","779":"d28ca4068e14baa98061"}[chunkId] + ".js";
};